import { CSSObject } from '@mui/system';

export const getHoverTouchStyles = (styles: CSSObject): CSSObject => ({
	'@media (hover: none)': {
		'&:active': {
			...styles,
		},
	},
	'@media (hover: hover)': {
		'&:hover': {
			...styles,
		},
	},
});
